<template>
    <div>
        <div class="row">
            <div class="col-md-9">
                <ul class="list-group user-account-group">
                    <li class="list-group-item">
                        <a @click.stop="showAccountMaintenance" href="#">#{{ account_nbr }} {{ account_nm }} </a>
                        ({{ account_city }},{{ account_state }})
                        <span class="label" :class="environmentDisplayClass">{{ industryDecode }}</span>

                        <a role="button" class="btn text m-l-10 add-pointer" @click.stop="" target="_blank"
                           :href="'http://intranet.midwestlabs.com/cgi-bin/accounts/accountEditFront.pl?account=' + account_nbr">
                            <span class="fa fa-external-link"></span>View in LIMS
                        </a>

                        <span v-show="has_pending_approval" class="label label-warning">Waiting Approval</span>
                    </li>

                    <account-role-item
                        v-for="(role,index) in all_roles"
                        :type="'approval'"
                        :role_cd="role.role_cd"
                        :role_desc="role.role_desc"
                        :user_account_roles="user_account_roles"
                        @add="addRole"
                        @delete="deleteRole"
                    ></account-role-item>
                </ul>
            </div>
            <div class="col-md-1 m-t-15">
                <span v-if="form_errors.length" class="simple-error">  {{ form_errors }} </span>
                <span v-if="form_status" class="simple-status"> {{ form_status }} </span>
            </div>
            <div class="col-md-2 m-t-15">
                <div class="pull-right">
                    <button @click="savePermissions" class="btn btn-primary btn-bold m-l-10"
                            :class="{  disabled : !data_changed }"><i class="fa fa-check"></i>Save <br> Permissions
                    </button>
                </div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
    module.exports = {
        props: [
            'user_id',
            'first_nm',
            'last_nm',
            'account_nbr',
            'account_nm',
            'account_city',
            'account_state',
            'account_industry_id',
            'has_pending_approval',
            'user_account_roles',
            'industry_list',
            'all_roles',
            'index'
        ],
        data: function () {
            return {
                data_changed: false,
                form_errors: {},
                form_status: '',
            }
        },
        computed: {
            hasPendingApproval: function () {
                const userAccountRolesLength = this.user_account_roles.length;
                for (let i = 0; i < userAccountRolesLength; i++) {
                    if (this.user_accounts_roles[i].value === 0) {
                        return true;
                    }
                }
                return false;
            },

            industryDecode: function () {
                let pos = (this.industry_list.map(function (a) {
                    return a.industry_id
                }).indexOf(this.account_industry_id));

                if (pos !== -1) {
                    return this.industry_list[pos].industry_nm.replace('&amp;', '&');
                }

                return '';
            },

            environmentDisplayClass: function () {
                return `industry-${this.industryDecode.substring(0, 3).toLowerCase()}`;
            }
        },
        methods: {
            showAccountMaintenance: function () {
                window.location.href = `/admin/accountroles/${this.account_nbr}`;
            },

            resetMessages: function (data_changed) {
                this.form_errors = {};
                this.form_status = '';
                this.data_changed = data_changed;
            },

            addRole: function (add_role_cd) {
                this.resetMessages(true);
                this.$emit('addUserAccountRolesArray', this.index, add_role_cd);
            },

            deleteRole: function (delete_role_cd) {
                this.resetMessages(true);
                this.$emit('delUserAccountRolesArray', this.index, delete_role_cd);
            },

            removeUnapprovedRoles: function () {
                for (let role_cd in this.user_account_roles) {
                    if ((this.user_account_roles.hasOwnProperty(role_cd)) && (this.user_account_roles[role_cd] === 1)) {
                        this.$emit('delUserAccountRolesArray', this.index, role_cd);
                    }
                }
            },

            savePermissions: function (role_cd) {
                this.resetMessages(this.data_changed);
                this.form_status = 'Saving...';

                this.removeUnapprovedRoles();
                const role_keys = Object.keys(this.user_account_roles);
                this.$http.post('/admin/users/approve-account-roles',
                    {
                        user_id: this.user_id,
                        account_nbr: this.account_nbr,
                        role_keys: role_keys
                    })
                    .then(function (response) {
                        this.form_status = response.data.status;
                        this.data_changed = false;
                    })
                    .catch(function (data, status, request) {
                        this.form_status = '';
                        this.form_errors = data.body.errors[0];
                    });

                this.$emit('resetPending', this.index);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// sys-admin-account-role-list.vue?44496171